import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BulkSearchModel } from '@models/BulkSearch';
import { ExcelValidationResult } from '@models/ExcelValidationResult';
import { MandatoryColumns } from '@models/MandatoryColumns';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BulkSearchService } from '@services/BulkSearchService';
import { CommonService } from '@services/common.service';
import { ExcelValidateService } from '@services/ExcelValidate';
import { SearchProfileService } from '@services/search-profile.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-bulk-search-modal',
  standalone: true,
  providers: [NgbModal],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  templateUrl: './bulk-search-modal.component.html',
  styleUrl: './bulk-search-modal.component.scss',
})
export class BulkSearchModalComponent implements OnInit, OnDestroy {
  selectedFile: File | null = null;
  activeModal = inject(NgbActiveModal);
  excelValidateService = inject(ExcelValidateService);
  commonService = inject(CommonService);
  spService = inject(SearchProfileService);
  bulkSearchService = inject(BulkSearchService);
  validateExcelSubscription!: Subscription;
  showUploadModal = true;
  enableUpload = false;
  hideFileList = false;
  fileName = '';
  isDownloading = false;
  submitButtonDisabled = true;
  excelValidationResult: ExcelValidationResult = new ExcelValidationResult();
  file: File|null=null;
  mandatoryColumns: MandatoryColumns[] = [
    {
      displayName: 's_no',
      regexp: /^[a-zA-Z0-9-]*$/,
      minLength: 0,
      maxLength: 0,
    },
    {
      displayName: 'name',
      regexp: /^[a-zA-Z0-9-,.() ]*$/,
      minLength: 0,
      maxLength: 0,
    },
    {
      displayName: 'address',
      regexp: /^[a-zA-Z0-9-,.() ]*$/,
      minLength: 0,
      maxLength: 0,
    },
    {
      displayName: 'city',
      regexp: /^[a-zA-Z0-9-,. ]*$/,
      minLength: 0,
      maxLength: 0,
    },
    {
      displayName: 'state',
      regexp: /^[a-zA-Z0-9-,. ]*$/,
      minLength: 0,
      maxLength: 0,
    },
    { displayName: 'zip', regexp: /^[0-9]*$/, minLength: 0, maxLength: 0 },
    { displayName: 'rcm_id', regexp: /^[0-9]*$/, minLength: 0, maxLength: 0 },
    { displayName: 'source',  regexp: /^[A-Za-z]+$/, minLength: 0, maxLength: 0, },
    {
      displayName: 'source_id',
      regexp: /^[a-zA-Z0-9-]*$/,
      minLength: 0,
      maxLength: 0,
    },
    {
      displayName: 'dea',
      regexp: /^[a-zA-Z0-9 ]*$/,
      minLength: 0,
      maxLength: 9,
    },
    {
      displayName: 'hin_no',
      regexp: /^[a-zA-Z0-9 ]*$/,
      minLength: 0,
      maxLength: 9,
    },
    {
      displayName: 'id_340b',
      regexp: /^[a-zA-Z0-9-]*$/,
      minLength: 0,
      maxLength: 0,
    },
    { displayName: 'npi', regexp: /^[0-9]*$/, minLength: 0, maxLength: 0 },
    {
      displayName: 'sln',
      regexp: /^[a-zA-Z0-9-,.]*$/,
      minLength: 0,
      maxLength: 0,
    },
    {
      displayName: 'tddd',
      regexp: /^[a-zA-Z0-9-,.]*$/,
      minLength: 0,
      maxLength: 0,
    },
    {
      displayName: 'hcce',
      regexp: /^[a-zA-Z0-9-,.]*$/,
      minLength: 0,
      maxLength: 0,
    },
    {
      displayName: 'type',
      regexp: /^[a-zA-Z]*$/,
      minLength: 0,
      maxLength: 0,
    },
  ];
  @ViewChild('fileDropRef') fileDropRef!: ElementRef<HTMLInputElement>;

  ngOnInit(): void {
    this.validateExcelSubscription =
      this.commonService.validateExcelSubject.subscribe(
        (res: ExcelValidationResult) => {
          this.excelValidationResult = res;
          this.submitButtonDisabled = !this.excelValidationResult.isValid;
        }
      );
  }
  ngOnDestroy(): void {
    if (this.validateExcelSubscription) {
      this.validateExcelSubscription.unsubscribe();
    }
  }
  onFileChange(pFileList: Event) {
    this.fileName = (pFileList.target as HTMLInputElement).files![0].name;
    this.enableUpload = false;
    this.hideFileList = false;
    this.showUploadModal = false;
    //this.validateAndUpload();
  }
  getFileName(event: Event) {
    this.file = (event.target as HTMLInputElement).files![0];
    const fileReader = new FileReader();
    const evResult = new ExcelValidationResult();
    this.excelValidateService.validateEXCELFiles(
      fileReader,
      this.file,
      this.mandatoryColumns,
      evResult
    );
    this.fileName = (event.target as HTMLInputElement).files![0].name;
    this.enableUpload = false;
    this.hideFileList = false;
    this.showUploadModal = false;
    //this.validateAndUpload();
  }
  deleteFile() {
    if (this.fileDropRef) {
      this.fileDropRef.nativeElement.value = '';
    }
    this.enableUpload = true;
    this.submitButtonDisabled = true;
    this.showUploadModal = true;
    this.fileName = '';
    this.submitButtonDisabled = true;
    this.file=null;
    this.clearValidation();
    
    // this.dataSet = [];
    // this.errorMessage = "";
  }

  downloadTemplate() {
    const link = document.createElement('a');
    link.href = 'assets/template/bulk-search-template.xlsx';
    link.download = 'bulk-search-template.xlsx';
    link.click();
  }
  onUpload() {
    //temp code
    // if (localStorage.getItem('bsresp')) {
    //   this.commonService.bulkSearchResponse.set(JSON.parse(localStorage.getItem('bsresp')!));
    //   this.activeModal.dismiss();
    //   this.commonService.bsBackButton.next('Result');
    //   return;
    // }
    //temp code

    const formData = new FormData();
    formData.append('file', this.file!);
    this.commonService.setShowLoader(true);

    //BULK SEARCH WITH SINGLE RESPONSE
    // this.spService.getBulkSearch(formData).subscribe((resData) => {
    //   localStorage.setItem('bsresp', JSON.stringify(resData.results));
    //   this.commonService.bulkSearchResponse.set(resData.results);
    //   this.commonService.setShowLoader(false);
    //   this.activeModal.dismiss();
    //   this.commonService.bsBackButton.next('Result');
    // })

    // BULK SEARCH WITH STREAM
    this.bulkSearchService.bulkSearchStatus.set('InProgress');
    this.bulkSearchService.uploadSubscription = this.bulkSearchService
      .uploadAndStream(formData)
      .subscribe({
        next: (data: BulkSearchModel) => {
          //console.log(data);
          this.commonService.setShowLoader(false);
          if (!data.status) {
            const bsResp = this.commonService.bulkSearchResponse();
            if (bsResp.length > 0) {
              this.commonService.bulkSearchResponse.update(
                (value: BulkSearchModel[]) => [...value, data]
              );
            } else {
              const bsResponse = [data];
              this.commonService.bulkSearchResponse.set(bsResponse);
              this.activeModal.dismiss();
              this.commonService.bsBackButton.next('Result');
            }
          } else {
            this.bulkSearchService.bulkSearchStatus.set('Completed');
          }
        },
        error: (err: Error) => console.error('Error:', err),
        complete: () => console.log('Stream complete'),
      });
  }
  clearValidation() {
    this.excelValidationResult = new ExcelValidationResult();
  }
  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length) {
      this.handleFile(files[0]);
    }
    const fileReader = new FileReader();
    const evResult = new ExcelValidationResult();
    this.excelValidateService.validateEXCELFiles(
      fileReader,
      this.file!,
      this.mandatoryColumns,
      evResult
    );
    this.fileName = (event.target as HTMLInputElement).files![0].name;
    this.enableUpload = false;
    this.hideFileList = false;
    this.showUploadModal = false;
  }

  onFileSelect(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) this.handleFile(file);
  }

  handleFile(file: File) {
    this.fileName = file.name;
    this.enableUpload = false;
    this.hideFileList = false;
    this.showUploadModal = false;
    this.file = file;
    if (!this.fileName) return;

    const formData = new FormData();
    formData.append('file', this.fileName);
    console.log('Uploading file:', this.fileName);
  }
}
